import React, { forwardRef, Fragment } from 'react'
import { PatternFormat } from 'react-number-format'
import { WidgetInputReactPhoneProps } from '../../widget-inputs'
import styles from '../../widget-inputs.module.scss'
import { MXIcon } from './mx-icon'

export const WidgetInputReactPhone = forwardRef<
  any,
  WidgetInputReactPhoneProps
>((props) => {
  const { inputStyles, labelStyles, placeholder, onChange } = props

  const inputBackground = inputStyles?.background ?? 'var(--pui-color-white)'
  const inputPadding = inputStyles?.padding ?? '10px'
  const inputBorder = inputStyles?.border ?? '1px solid #8797A1'
  const labelColor = labelStyles?.color ?? '#495863'
  const labelBackground = labelStyles?.background ?? '#F6F9FB'
  const codeColor = labelStyles?.color ?? '#2F3A44'

  return (
    <Fragment>
      <div
        className={
          props?.error ? styles['form__react__select__error'] : undefined
        }
        data-testid="widget-input-wrapper"
      >
        <span style={{ color: labelColor }}>{placeholder}</span>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div
            style={{
              padding: '9px',
              border: inputBorder,
              display: 'inline-flex',
              borderRadius: '8px 0px 0px 8px',
              background: labelBackground,
            }}
          >
            <MXIcon />
            <span style={{ marginLeft: '5px', color: codeColor }}>+52</span>
          </div>
          <PatternFormat
            format="## #### ####"
            mask=""
            valueIsNumericString
            placeholder="11 2222 3333"
            onValueChange={onChange}
            required
            style={{
              borderRadius: '0px 8px 8px 0px',
              padding: inputPadding,
              border: inputBorder,
              height: '18px',
              width: '100%',
              outline: 'none',
              background: inputBackground,
            }}
          />
        </div>

        {props?.error && (
          <span
            className={`${styles['form__message']} ${styles['form__message--visible']} ${styles['form__message--error']}`}
          >
            {props?.error}
          </span>
        )}
      </div>
    </Fragment>
  )
})

WidgetInputReactPhone.displayName = 'WidgetInputReactPhone'
